import { render, staticRenderFns } from "./coderInpatientFindings.vue?vue&type=template&id=1b875704&scoped=true&"
import script from "./coderInpatientFindings.vue?vue&type=script&lang=js&"
export * from "./coderInpatientFindings.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientFindings.vue?vue&type=style&index=0&id=1b875704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b875704",
  null
  
)

export default component.exports